import { NotificationEventEnum } from '.'
import { NotificationEventItem } from './NotificationEventItem'

const Issued = new NotificationEventItem({
  id: '4B3A025E-1C2A-45FA-9018-388D04164A78',
  name: 'Issued',
  description: `An Engineering Judgement is issued`,
})

export type EJNotificationEventItem = typeof Issued

class EJNotificationEnum extends NotificationEventEnum<
  'EJNotification',
  EJNotificationEventItem,
  EJNotificationEventItem['name'],
  EJNotificationEventItem['id']
> {
  typename = 'EJNotification' as const
  get values() {
    return [this.Issued]
  }
  readonly Issued = Issued
}

export const EJNotificationEvent = new EJNotificationEnum()
